<template>
    <div class="admin_main_wrapper">
        <b-list-group class="unlinked_list">
            <croImportDialog :settings="croImportDialogSettings" v-if="croImportDialogSettings.show"></croImportDialog>
            <croFogImportDialog :settings="croFogImportDialogSettings" v-if="croFogImportDialogSettings.show"></croFogImportDialog>
            <div class="top_buttons_wrapper">
                <b-button variant="secondary" block @click="showCroImportDialog" style="width: 300px;">
                    Import CRO data
                </b-button>
                <b-button variant="secondary" block @click="showCroFogImportDialog" style="width: 300px;">
                    Import CRO FOG data
                </b-button>
                <b-button variant="secondary" block @click="showFetchGoogleBusinessesDialog" style="width: 300px;">
                    Fetch google businesses
                </b-button>
            </div>
            <form>
                <b-list-group-item v-for="(item, index) in UnlinkedQuestionsArray" :key="index" class="unlinked_item">
                    <input type="checkbox" name="question_uids[]" :value="item.uid" v-model="UnlinkList">
                    <div class="place_name"
                         @click="selectPlace(item.uid, 'edit', item.text, item.optional, item.link)">
                        ({{item.id}}) {{item.text}}
                    </div>
                    <div class="printed-mark">
                        <i v-if="item.printed" class="fa fa-print"></i>
                    </div>
                    <img :alt="item.name" src="@/assets/images/simpleStore.png" style="margin-right: 0;"
                         @click="clickUnlinkedQuestions(item.uid, item)">
                </b-list-group-item>
                <div class="buttons-panel">
                    <b-button v-if="UnlinkList.length && isEveryPrinted" type="submit" variant="primary" block
                              class="add-qr" @click.prevent="markQuestionAsPrinted">Mark as Printed
                    </b-button>
                    <b-button v-if="UnlinkList.length && isSomePrinted" type="submit" variant="danger" block
                              class="add-qr" @click.prevent="removePrintedMark">Remove Mark as Printed
                    </b-button>
                    <b-button v-if="UnlinkList.length" type="submit" variant="primary" block class="add-qr"
                              @click.prevent="onCreatePdfClick(UnlinkList)">PDF
                    </b-button>
                    <b-button
                            variant="secondary"
                            block
                            v-if="!UnlinkList.length"
                            @click="addQuestionModal"
                            class="add-qr"
                            v-text="translate('admin_Add')">
                        Add
                    </b-button>
                </div>

            </form>
            <infinite-loading :identifier="infinityValue" @infinite="getListUnlinked">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </b-list-group>

        <div class="face-container-add unlinked" :style="{ display: [showModalAdd ? 'flex' : 'none']}">
            <ul>
                <li class="close">
                    <button @click="showModalAdd=false"></button>
                </li>
                <li>
                    <label>Count</label>
                    <b-form-input id="count" type="number" v-model="count"></b-form-input>
                </li>
                <li>
                    <label>Question</label>
                    <b-form-textarea row="2" maxlength="100" id="question" type="text"
                                     v-model="question"></b-form-textarea>
                </li>
                <li>
                    <label>Location</label>
                    <b-form-input id="location" type="text" v-model="location"></b-form-input>
                </li>
                <li>
                    <b-form-checkbox v-model="useDefaultAnswers">
                        <span>Use default answers</span>
                    </b-form-checkbox>
                    <div class="new_question_answers" v-if="!useDefaultAnswers">
                        <b-form-input id="green" type="text" v-model="green" placeholder="Green"></b-form-input>|
                        <b-form-input id="yellow" type="text" v-model="yellow" placeholder="Yellow"></b-form-input>|
                        <b-form-input id="red" type="text" v-model="red" placeholder="Red"></b-form-input>
                    </div>
                </li>
                <li>
                    <b-button variant="success" @click="AddQuestionUnlinked()" v-text="translate('admin_Add')">
                        Add
                    </b-button>
                </li>
            </ul>
        </div>

        <div class="face-container-add unlinked change-modal"
             :style="{ display: [showModalChange ? 'flex' : 'none']}">
            <ul>
                <li class="close">
                    <button @click="hideChangeModal"></button>
                </li>
                <li>
                    <label for="question">{{translate('Question')}}</label>
                    <b-form-textarea maxlength="100" class="max-row-2" max-rows="2" id="question" type="text"
                                     v-model="question"></b-form-textarea>
                </li>
                <li>
                    <label for="location">{{translate('Location')}}</label>
                    <b-form-input id="location" type="text" v-model="location"></b-form-input>
                </li>
                <li>
                    <b-button size="sm" variant="primary" :disabled="loadingUpdate"
                              @click="ChangeQuestionUnlinked()">
                        <b-spinner v-if="loadingUpdate" small></b-spinner>
                        {{ translate('Save') }}
                    </b-button>

                    <b-button size="sm" variant="danger" v-if="ShowDelete" :disabled="loadingDelete"
                              @click="RemoveQuestionUnlinked()">
                        <b-spinner v-if="loadingDelete" small></b-spinner>
                        {{ translate('admin_Delete') }}
                    </b-button>

                </li>
            </ul>
        </div>

        <!--  Place List Modal  -->
        <div class="face-container-add unlinked connect-place"
             :style="{ display: [showModal ? 'flex' : 'none']}">
            <ul>
                <li class="close">
                    <button @click="showModal=false"></button>
                </li>
                <li>
                    <label style="text-align: center" v-text="translate('admin_ChooseYourPlace')"></label>
                    <b-form-input v-model="searchInput" :placeholder="translate('admin_searchByName')"
                                  @input="searchPlaceForUnlinked"></b-form-input>
                </li>
                <li class="modal-place-container" style="margin: 0; max-height: 40vh;">
                    <b-list-group class="modal-place">
                        <b-list-group-item v-for="(item, index) in ratesModalList" :key="index"
                                           @click="setPlace(item.uid)">
                            <img :src="item.preview">
                            <div class="place_name">{{item.name}}</div>
                        </b-list-group-item>
                    </b-list-group>
                    <infinite-loading :identifier="infinitePlacesList" @infinite="getListPlacesToLinked">
                        <div slot="no-more"></div>
                        <div slot="no-results"></div>
                    </infinite-loading>
                </li>
            </ul>
        </div>
        <b-modal v-model="showPdfConfigDialog" content-class="custom-modal">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="showPdfConfigDialog=false"></span>
            </template>

            <div v-if="true">
                <b-form-group class="mt-3">
                    Page width in millimeters:
                    <b-form-input
                            id="input-formatter"
                            v-model="pdfConfigDialogModel.page_width"
                            placeholder="Enter page width"
                    ></b-form-input>
                </b-form-group>
                Page height in millimeters:
                <b-form-group class="mt-3">
                    <b-form-input
                            id="tooltip-button-variant"
                            v-model="pdfConfigDialogModel.page_height"
                            placeholder="Enter page height"
                    ></b-form-input>
                </b-form-group>
                Sticker width in millimeters:
                <b-form-group class="mt-3">
                    <b-form-input
                            id="input-formatter"
                            v-model="pdfConfigDialogModel.sticker_width"
                            placeholder="Enter sticker width"
                    ></b-form-input>
                </b-form-group>
                Count of columns in pdf:
                <b-form-group class="mt-3">
                    <b-form-input
                            id="input-formatter"
                            v-model="pdfConfigDialogModel.col_count"
                            placeholder="Enter columns count"
                    ></b-form-input>
                </b-form-group>
                Sticker type
                <vSelect
                        :clearable="false"
                        :options="UnlinkedQuestionsArray.sticker_types"
                        :searchable="false"
                        label="Sticker type"
                        v-model="pdfConfigDialogModel.sticker_type">
                </vSelect>
                <div>
                    <b-form-checkbox v-model="pdfConfigDialogModel.show_border">With border
                    </b-form-checkbox>
                </div>
            </div>

            <template v-slot:modal-footer>
                <b-button variant="default" class="secondary" @click="showPdfConfigDialog=false">
                    {{ translate('Cancel') }}
                </b-button>

                <b-button variant="primary" :disabled="loadingUpdate" @click="generatePdfLink()">
                    Generate
                </b-button>

            </template>
        </b-modal>

        <b-modal v-model="showGoogleBusinessesConfigDialog" content-class="custom-modal">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="showGoogleBusinessesConfigDialog=false"></span>
            </template>

            <div v-if="!fetchGoogleBusinessesTaskId">
                <b-form-group class="mt-3">
                    Lat:
                    <b-form-input
                        id="input-formatter"
                        v-model="googleBusinessesFetchModel.lat"
                        placeholder="Lat"
                    ></b-form-input>
                </b-form-group>
                Lng
                <b-form-group class="mt-3">
                    <b-form-input
                        id="tooltip-button-variant"
                        v-model="googleBusinessesFetchModel.lng"
                        placeholder="Lng"
                    ></b-form-input>
                </b-form-group>
                Radius (in meters)
                <b-form-group class="mt-3">
                    <b-form-input
                        id="input-formatter"
                        v-model="googleBusinessesFetchModel.radius"
                        placeholder="Radius"
                    ></b-form-input>
                </b-form-group>
                Language
                <b-form-group class="mt-3">
                    <b-form-input
                        id="input-formatter"
                        v-model="googleBusinessesFetchModel.language"
                        placeholder="Language"
                    ></b-form-input>
                </b-form-group>
                Type
                <b-form-group class="mt-3">
                    <b-form-input
                        id="input-formatter"
                        v-model="googleBusinessesFetchModel.type"
                        placeholder="Type"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div v-if="fetchGoogleBusinessesTaskId != null">
                <textarea id="fetch_business_status_ta" style="height: 150px; width: 400px;">{{fetchBusinessesStatus.step}}</textarea>
            </div>

            <template v-slot:modal-footer>
                <b-button variant="default" class="secondary" @click="showGoogleBusinessesConfigDialog=false">
                    {{ translate('Cancel') }}
                </b-button>

                <b-button variant="primary" v-if="!fetchGoogleBusinessesTaskId" @click="fetchGoogleBusinesses()">
                    Generate
                </b-button>

            </template>
        </b-modal>
        <!--  Pdf generete modal  -->
        <div class="face-container-add unlinked pdf-generate-modal"
             :style="{ display: [loadingPdfModal ? 'flex' : 'none']}">
            <ul>
                <li class="close">
                    <button @click="togglePdfModal(false)"></button>
                </li>
                <li>
                    <label class="text-center">Generating PDF</label>
                    <b-progress
                            :value="pdfStatus.progress"
                            :max="100"
                            :show-progress="pdfStatus.status !== 'done'"
                            :animated="pdfStatus.status !== 'done'"
                    ></b-progress>
                    <b-button variant="success" :disabled="pdfStatus.status !== 'done'" @click="getPdf">PDF Link
                    </b-button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import InfiniteLoading from 'vue-infinite-loading';
    import croImportDialog from '@/components/widgets/croImportDialog';
    import croFogImportDialog from '@/components/widgets/croFogImportDialog';
    import config from '@/api/config';
    import vSelect from 'vue-select'
    import errorMixin from "@/mixins/errorMixin";
    import adminPageMixin from "@/mixins/adminPageMixin";
    export default {
        mixins: [errorMixin, adminPageMixin,],
        name: "UnlinkedQuestions",
        components: {
            InfiniteLoading,
            croImportDialog,
            croFogImportDialog,
            vSelect
        },
        data () {
            return {
                UnlinkedQuestionsArray: [],
                searchInput: '',
                loadingAction: false,
                unlinkedUID: undefined,
                UnlinkedQuestionsUID: undefined,
                UnlinkList: [],
                question: '',
                location: '',
                count: '',
                useDefaultAnswers: true,
                green: '',
                yellow: '',
                red: '',
                showModal: false,
                showModalAdd: false,
                croImportDialogSettings: {},
                croFogImportDialogSettings: {},
                showModalChange: false,
                loadingUpdate: false,
                loadingDelete: false,
                ShowDelete: true,
                ratesModalList: [],
                infinitePlacesList: 0,
                infiniteUnlinkedQuestions: 0,
                page: 1,
                UnlinkPDF: undefined,
                searchTimer: null,
                infinityValue: 0,
                showPdfConfigDialog: false,
                pdfConfigDialogModel: {
                    page_width: 210,
                    page_height: 290,
                    sticker_width: 190,
                    col_count: 1,
                    sticker_type: 'default',
                    show_border: false,
                    guids: []
                },
                fetchGoogleBusinessesTaskId: null,
                showGoogleBusinessesConfigDialog: false,
                googleBusinessesFetchModel: {
                    lat: 30.256760,
                    lng: -97.890504,
                    radius: 5000,
                    language: 'en',
                    type: 'restaurant',
                },
                fetchBusinessesStatus: {
                    step: ''
                },
                pdfStatus: {
                    progress: 0
                },
           }
        },
        props: ['infinity'],
        watch: {
            infinity(val) {
                this.page = 1
                this.infinityValue += 1
            },
        },
        computed: {
            ...mapState({
                loadingPdfModal: state => state.pdf.loadingPdfModal,
            }),
            isEveryPrinted() {
                return !this.UnlinkList.every(questionId => {
                    const question = this.getQuestionByID(questionId)
                    return question.printed
                })
            },
            isSomePrinted() {
                return this.UnlinkList.some(questionId => {
                    const question = this.getQuestionByID(questionId)
                    return question.printed
                })
            },
        },
        mounted() {
            this.initAdminPage()
        },
        methods: {
            ...mapActions({
                fetchPlacesList: 'place/fetchPlacesList',
                fetchUnlinkedQuestions: 'question/fetchUnlinkedQuestions',
                createQuestion: 'question/createQuestion',
                updateQuestion: 'question/updateQuestion',
                deleteQuestion: 'question/deleteQuestion',
                setMultipleQuestionAsPrinted: 'question/setMultipleQuestionAsPrinted',
                removeMultiplePrintedFlag: 'question/removeMultiplePrintedFlag',
                connectQuestionToPlaceAdmin: 'question/connectQuestionToPlaceAdmin',
                generatePdfLinkAction: 'pdf/generatePdfLink',
                chekPdfStatus: 'pdf/chekPdfStatus',
                fetchGoogleBusinessesAction: 'googleBusinesses/fetchBusinesses',
                googleBusinessesStatus: 'googleBusinesses/checkStatus',

            }),
            ...mapMutations({
                setPdfStatus: 'pdf/setPdfStatus',
                togglePdfModal: 'pdf/togglePdfModal',
            }),
            getQuestionByID(questionID) {
                return this.UnlinkedQuestionsArray.find(item => item.uid === questionID)
            },
            async getListPlacesToLinked(stateInf) {
                try {
                    this.loadingAction = true
                    const response = await this.fetchPlacesList({
                        isMyPlaces: false,
                        page: this.pageModalList,
                        get_all: true,
                        searchText: this.searchInput
                    });
                    if (response.success) {
                        this.pageModalList += 1;
                        if (this.ratesModalList.length == 0) {
                            this.ratesModalList = response.places
                        } else {
                            response.places.forEach((item) => {
                                this.ratesModalList.push(item)
                            })
                            console.log(this.ratesModalList)
                        }
                        if (stateInf) {
                            if (response.places.length === 10) {
                                stateInf.loaded();
                            } else {
                                stateInf.complete();
                            }
                        }
                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    console.log(e)
                    this.showErrorModal()
                } finally {
                    this.loadingAction = false
                }
            },
            async getListUnlinked(stateInf) {
                try {
                    this.loadingAction = true
                    const response = await this.fetchUnlinkedQuestions({
                        page: this.page
                    })
                    if (response.success) {
                        if (this.page == 1) {
                            this.UnlinkedQuestionsArray = []
                        }
                        response.qrs.forEach((item) => {
                            this.UnlinkedQuestionsArray.push(item)
                        })
                        this.page += 1
                        for (var i = 0; this.UnlinkedQuestionsArray.length > i; i++) {
                            this.UnlinkedQuestionsArray[i].link = `/admin/questions/${this.UnlinkedQuestionsArray[i].uid}/pdf`
                        }
                        if (stateInf) {
                            if (response.qrs.length === 100) {
                                stateInf.loaded();
                            } else {
                                stateInf.complete();
                            }
                        }
                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    this.showErrorModal()
                } finally {
                    this.loadingAction = false
                }
            },
            showCroImportDialog() {
                this.croImportDialogSettings = {
                    show: true
                }
            },
            showCroFogImportDialog() {
                this.croFogImportDialogSettings = {
                    show: true
                }
            },
            async AddQuestionUnlinked() {

                var body = {
                    count: this.count,
                    text: this.question,
                    optional: this.location
                };
                if(!this.useDefaultAnswers) {
                    body.green = this.green
                    body.red = this.red
                    body.yellow = this.yellow
                }
                try {
                    const response = await this.createQuestion(body)
                    if (response.success) {
                        this.clearQuestion()
                        this.showModalAdd = false;
                        this.getListUnlinked();
                        this.refreshUnlinkedQuestions()
                    } else {
                        this.showErrorModal('Error', {title: 'CancelRequest'})
                    }
                } catch (e) {
                    this.showErrorModal('Error', {title: 'CancelRequest'})
                }

            },
            refreshUnlinkedQuestions() {
                if (this.searchTimer) {
                    clearTimeout(this.searchTimer);
                }
                this.searchTimer = setTimeout(() => {
                    this.page = 1
                    this.UnlinkedQuestionsArray = []
                    this.infinityValue += 1
                }, 450);
            },
            clearQuestion() {
                this.question = '';
                this.location = '';
                this.count = '';
            },
            async generatePdfLink() {
                this.showPdfConfigDialog = false
                this.pdfStatus = {progress: 0}
                this.setPdfStatus({progress: 0})
                this.togglePdfModal(true)
                this.generatePdfId = await this.generatePdfLinkAction({
                    list: this.pdfConfigDialogModel.guids,
                    pdfConfig: this.pdfConfigDialogModel
                })

                this.intervalId = setInterval(() => {
                    this.chekPdfStatus(this.generatePdfId).then((response) => {
                        this.pdfStatus = response
                        if (response.status === 'done') {
                            clearInterval(this.intervalId);
                        }
                    })
                }, 1200)
            },
            async getPdf() {
                const win = window.open(`${config.baseUrl}/admin/pdf/${this.pdfStatus.uid}`, '_blank');
                win.focus();
            },
            showFetchGoogleBusinessesDialog() {
                this.fetchGoogleBusinessesTaskId = null
                this.showGoogleBusinessesConfigDialog = true
            },
            async fetchGoogleBusinesses() {
                this.fetchBusinessesStatus = {step: ''}
                this.fetchGoogleBusinessesTaskId = await this.fetchGoogleBusinessesAction({
                    lat: this.googleBusinessesFetchModel.lat,
                    lng: this.googleBusinessesFetchModel.lng,
                    radius: this.googleBusinessesFetchModel.radius,
                    language: this.googleBusinessesFetchModel.language,
                    type: this.googleBusinessesFetchModel.type,
                })

                let thiz = this
                this.fetchGoogleBusinessesIntervalId = setInterval(() => {
                    this.googleBusinessesStatus(this.fetchGoogleBusinessesTaskId).then((response) => {
                        this.fetchBusinessesStatus.step = response.step
                        if (response.status === 'done' || response.status === 'error') {
                            clearInterval(this.fetchGoogleBusinessesIntervalId);
                        }
                        if (response.status === 'done') {
                            this.fetchBusinessesStatus.step = response.step
                        }
                        if (response.status === 'error') {
                            this.fetchBusinessesStatus.step = response.error || response.step
                        }
                        var textarea = document.getElementById('fetch_business_status_ta');
                        textarea.scrollTop = textarea.scrollHeight;
                    })
                }, 200)
            },

            async RemoveQuestionUnlinked() {
                if (this.UnlinkList.length) {
                    this.UnlinkList.splice(this.UnlinkList.indexOf(this.unlinkedUID), 1)
                }
                this.loadingDelete = true
                try {
                    const response = await this.deleteQuestion({
                        questionId: this.unlinkedUID
                    })
                    this.loadingDelete = false
                    if (response.success) {
                        this.clearQuestion()
                        this.showModalChange = false;
                        this.getListUnlinked();
                        this.refreshUnlinkedQuestions()
                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    this.loadingDelete = false
                    this.showErrorModal('Error', {title: 'CancelRequest'})
                }

            },

            async ChangeQuestionUnlinked() {
                const body = {
                    text: this.question,
                    optional: this.location
                };

                this.loadingUpdate = true
                try {
                    const response = await this.updateQuestion({
                        questionId: this.unlinkedUID,
                        body
                    })
                    this.loadingUpdate = false

                    if (response.success) {
                        this.getListUnlinked();
                        this.refreshUnlinkedQuestions()

                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    this.loadingUpdate = false
                    this.showErrorModal('Error', {title: 'CancelRequest'})
                }

            },
            async onCreatePdfClick(guids) {
                this.showPdfConfigDialog = true
                console.log(guids)
                this.pdfConfigDialogModel.guids = guids
            },
            selectPlace(uid, choose, question, location, link) {
                this.unlinkedUID = uid;
                this.question = question;
                this.location = location;
                this.UnlinkPDF = link;
                switch (choose) {
                    case 'place': {
                        this.setPlace(uid)
                        break;
                    }
                    case 'edit': {
                        this.showModalChange = true;
                        break;
                    }
                }
            },

            async setPlace(uid) {
                var body = {
                    place_id: uid
                };
                try {
                    const response = await this.connectQuestionToPlaceAdmin({
                        questionId: this.UnlinkedQuestionsUID,
                        body
                    })
                    if (response.data.success) {
                        this.showModal = false;
                        this.ShowDelete = false
                        this.showModalChange = true;
                        this.showConfirmModal(false)
                        await this.getListUnlinked();
                        this.UnlinkedQuestionsArray.filter(item => item.uid)
                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    this.showErrorModal('Error', {title: 'CancelRequest'})
                }
            },
            async markQuestionAsPrinted() {
                try {
                    await this.setMultipleQuestionAsPrinted(this.UnlinkList)
                    this.UnlinkList.forEach(questionId => {
                        const question = this.getQuestionByID(questionId)
                        question.printed = true
                    })
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },

            async removePrintedMark() {
                try {
                    await this.removeMultiplePrintedFlag(this.UnlinkList)
                    this.UnlinkList.forEach(questionId => {
                        const question = this.getQuestionByID(questionId)
                        question.printed = false
                    })
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },
            clickUnlinkedQuestions(uid, item) {
                this.infinitePlacesList += 1;
                this.pageModalList = 1;
                this.showModal = true;
                this.UnlinkedQuestionsUID = uid;
                this.ratesModalList = [];
                this.selectPlace(item.uid, null, item.text, item.optional, item.link)
            },
            searchPlaceForUnlinked() {
                this.infinitePlacesList += 1;
                this.pageModalList = 1;
                this.ratesModalList = [];
            },
            addQuestionModal() {
                this.showModalAdd = true;
                this.count = 1;
                this.question = '';
                this.location = '';
            },

            hideChangeModal() {
                this.showModalChange = false
                this.ShowDelete = true;
            },
        }
    }
</script>

<style scoped>
    .unlinked_list {
        max-height: calc(100vh - 62px);
        overflow: auto;
        margin-bottom: 0;
        padding-bottom: 5em;
    }
    .face-container-add .list-group-item .place_name {
        max-width: calc(100% - 2em);
    }
    .place_name {
        margin-left: 10px;
        width: 100%;
        padding-right: 30px;
    }
    .printed-mark {
        min-width: 20px;
        margin: 0 25px;
        font-size: 22px;
        color: #6c757d;
        display: inline-block;
    }
    .list-group-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        transition: all 0.15s ease;
        display: -ms-flexbox;
        display: -webkit-flex;
    }
    .list-group-item:hover {
        background: #6c757d5c
    }

    .info-status {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%);
        width: 90vw;
    }

    .list-group-item .place_rate {
        width: 3.5em;
        transform: scale(1.9);
    }

    .list-group-item img {
        transform: scale(1.5);
        margin-right: 30px;
        width: 20px;
        height: 20px;
    }
    .face-container-add.unlinked {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, .6);
        min-height: 100vh;
        z-index: 9;
    }

    .face-container-add.unlinked input {
        margin-bottom: 1em;
        text-align: center;
    }

    .face-container-add.unlinked ul {
        background: #fff;
        display: flex;
        max-width: 90vw;
    }

    .face-container-add.unlinked ul {
        position: relative;
        margin: 0;
        padding: 1.3em 0;
        border-radius: 1em;
        flex-direction: column;
    }

    .face-container-add.connect-place.unlinked ul {
        width: 770px;
        height: 70vh;
        max-height: 385px;
    }

    .face-container-add.unlinked ul li {
        margin-bottom: .7em;
        display: flex;
        flex-direction: column;
    }

    .face-container-add.unlinked ul li:last-child button {
        margin-top: 1em;
    }

    .face-container-add.unlinked ul li img {
        width: 100%;
    }

    .face-container-add.unlinked ul li.close {
        width: 1.4em;
        height: 1.4em;
        position: absolute;
        top: .35em;
        right: 0em;
    }

    .face-container-add.unlinked ul li.close {
        /*top: -3em;*/
    }

    .face-container-add ul li.close button {
        width: 1.4em;
        height: 1.4em;
        background: none;
        border: 0;
    }

    .face-container-add ul li.close button:before,
    .face-container-add ul li.close button:after {
        content: '';
        position: absolute;
        width: 100%;
        height: .1em;
        background: #2F2F2F !important;
        border-radius: .2em;
        border: 0;
        background: 0;
        left: 0;
    }

    .face-container-add ul li.close button:before {
        transform: rotate(45deg);
    }

    .face-container-add ul li.close button:after {
        transform: rotate(-45deg);
    }

    .face-container-add .modal-place-container {
        margin: 0;
        max-height: 40vh;
        max-height: 70vw;
        overflow: auto;
    }

    .face-container-add .modal-place-container .list-group {
        margin-bottom: 0;
    }

    .face-container-add .list-group-item {
        display: flex;
        flex-direction: row;
    }

    .face-container-add .list-group-item .image,
    .face-container-add .list-group-item img {
        max-width: 1.5em;
        height: 1.5em;
        display: block;
    }

    .face-container-add .list-group-item .place_name {
        max-width: calc(100% - 2em);
    }
    .pdf-generate-modal ul {
        min-width: 400px;
    }

    .pdf-config-modal ul {
        min-width: 400px;
    }

    .pdf-generate-modal.unlinked ul li.close {
        top: -3rem;
    }
    .new_question_answers {
        display: flex;
        margin-top: 12px;
    }
    .top_buttons_wrapper {
        display: flex;
    }
    @media screen and (max-width: 645px) {
        .top_buttons_wrapper {
            flex-direction: column;
        }
    }
</style>